<template>
  <div>

    <a  @click="fnShowModal()" class="p-2"><i class="far fa-edit text-primary"></i></a>

    <b-modal ref="modal" hide-footer title="Business use percentage">
        <div class="d-block">
          <form>

            <div class="form-group">
              <label for="percentage">Percentage</label>
              <input type="text" 
              class="form-control" 
              id="percentage" 
              placeholder="Percentage"
              v-model="percentage">
              <div class="invalid-feedback" v-if="errors.percentage">{{ errors.percentage[0] }}</div>
            </div>
           <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                >
                Status
            </b-form-checkbox>
          <hr>
          <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button  type="button" @click="fnUpdate()" class="btn btn-success btn-sm">Update</button>
          </div>
          </form>
        </div>
      </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as businessUsePercentageService from '../../services/businessUsePercentage.service';
    export default {
        name:"ModalBusinessUsePercentageEdit",
        props:['propsData'],
        components: {
            
        },
        data(){
            return{
                errors:{},
                id:'',
                percentage:'',
                status:'',
            }
        },
        computed:{
            ...mapGetters(['gettBusinessUsePercentageAll']),
        },
        methods:{
            ...mapActions(['fetchBusinessUsePercentageAll']),
            fnShowModal(){
                this.fnGetValue(this.propsData)
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            fnGetValue(props){
                this.id = props.rowData.id;
                this.status = props.rowData.status;
                this.percentage = props.rowData.percentage;
            },

            fnUpdate:async function(){
                const obj = {
                    "percentage":this.percentage,
                    "status":this.status
                }

                try{
                    const response = await businessUsePercentageService.update(this.id, obj);
                    this.fetchBusinessUsePercentageAll();
                    messageService.fnSweetAlertSuccessToast('Business use percentage', 'Updated successfully ');
                    this.hideModal();

                }catch(error){
                    messageService.fnSweetAlertErrorToast('Business use percentage - update', error.response.data.message);
                }

                this.id = ''; 
                this.percentage = '';
                this.status ='';
            }
        }
    }
</script>